
import React from 'react';
import Grid from '@mui/material/Unstable_Grid2';
import useViewPDFPage from './useViewPDFPage';
import MultipleSelectV2 from '../../components/Select/MultiSelectV2';
import AlertBar from '../../components/AlertBar/AlertBar';
import { SIZE } from '../../constants/field-size';
import SignatoryPage from './SignatoryPage/SignatoryPage';
import Modal from '../../components/Modal/Modal';
import useOpenSignatory from './useOpenSignatory';
import PDFCard from './PDFCard/PDFCard';
import { getFileICon } from '../../utils/utilities';
import { STATUS } from '../../constants/form-status';
import UploadButton from '../../components/Button/UploadButton';
import { MODE } from '../../constants/form-mode';
import TransactionDetails from '../FormPage/TransactionDetails/TransactionDetails';

const ViewPDFPage = ( {
    isOverwriteSignature,
    isAgentRestricted,
    step
}) => {
    
    const {
        // selectedForms,
        allPDFTemplates,
        btnAction,
        onSelectTemplates,
        selectedTemplates,
        sharedForms,
        templateFieldDisable,
        signButtonLabel,
        copy,
        pageAlert,
        supportingDocuments,
        mode,
        status,
        getPublicLink,
        disabledForms,
        isFileExists
    } = useViewPDFPage();
 
    const {
        handleOpenSignatories,
        openedFile,
        modalBtn,
    } = useOpenSignatory();
    
    return (
        <>
            {/* step 1 = view and share pdf
                step 2 = upload and sign
            */}
            {step === 2 &&
                <TransactionDetails />
            }
            <Grid container spacing={2}>
                {/* {!isAgentRestricted && */}
                {step === 1 &&
                    <>
                        <Grid xs={12} md={12} >
                            <MultipleSelectV2
                                label={"Templates"}
                                options={allPDFTemplates.map(template => template.FormName)}
                                value={selectedTemplates}
                                setValue={val => onSelectTemplates(val)}
                                size={SIZE.XL}
                                disabled={templateFieldDisable}
                                disabledItems={disabledForms}
                            />
                        </Grid>
                        {mode !== MODE.CLOSED &&
                            <Grid xs={12} md={12}>
                                <UploadButton
                                    onFileUpload={(e) => btnAction.handleUploadSupportingDocs(e)}
                                    label={"Upload Supporting Documents"}
                                    // sx={{ width: '100%', mb: 2, borderRadius: '20px' , textAlign: "center" , padding : 2  }}
                                    sx={{ mb: 2, fontSize: 11 }}
                                    color={"success"}
                                    allowMultiple={true}
                                    acceptableFile=".pdf, .xls, .xlsx, .doc, .docx, image/*"
                                    variant={"contained"}
                                // loading={loading}
                                />
                            </Grid>
                        }
                    </>
                } 
                
                {step === 1 && allPDFTemplates
                    .filter(pdf => selectedTemplates.includes(pdf.FormName) ) //filter all templates based on selected templates from dropdown
                    .map((file) =>
                        <PDFCard 
                            title={`${file.FormName}.pdf`}
                            publicLink={getPublicLink(file.Id , 0)}
                            file={file}
                            fileIcon={getFileICon((`${file.FormName}.pdf`))}
                            handleViewFile={() => btnAction.handleViewFile(file)}
                            // handleOpenSignatories={() => handleOpenSignatories(file)}
                            // handleDownloadFile={() => btnAction.handleDownloadFile(file)}
                            // handleUploadFile={(e) => btnAction.handleUploadFile(e, file , isOverwriteSignature)}
                            handleShareFile={() => btnAction.handleShareFile(file.Id, file.FormName , 0)}
                            // handleCopyLink={() => btnAction.handleCopyLink(file.Id , 0)}
                            // handleMarkSharing={isAgentRestricted ? null : () => btnAction.handleMarkSharing(file)}
                            templateFieldDisable={templateFieldDisable}
                            signButtonLabel={signButtonLabel}
                            key={file.Id}
                            formMode={mode}
                            sharedForms={sharedForms}
                            layout={"VERTICAL"}
                        />
                )}

                { step === 2 && allPDFTemplates
                    .filter(pdf => selectedTemplates.includes(pdf.FormName) ) //filter all templates based on selected templates from dropdown
                    .map((file) =>
                        <PDFCard 
                            title={`${file.FormName}.pdf`}
                            file={file}
                            fileIcon={getFileICon((`${file.FormName}.pdf`))}
                            templateFieldDisable={templateFieldDisable}
                            signButtonLabel={signButtonLabel}
                            key={file.Id}
                            handleOpenSignatories={() => handleOpenSignatories(file)}
                            handleUploadFile={(e) => btnAction.handleUploadFile(e, file , isOverwriteSignature)}
                            handleViewFile={() => btnAction.handleViewFile(file)}
                            layout={"HORIZONTAL"}
                            isFileExists={isFileExists}
                            formMode={mode}
                        />
                )}
                
                {/* supporting documents */}
                {  supportingDocuments
                    .map( ( doc) =>
                        <PDFCard
                            title={`(Supporting Documents): ${doc.FormName}`}
                            file={doc}
                            publicLink={getPublicLink(doc.FormName , 1)}
                            fileIcon={getFileICon((doc.FormName))}
                            handleRemoveFile = {mode !== MODE.CLOSED ? () => btnAction.handleRemoveFile(doc) : ""}
                            handleDownloadFile={() => btnAction.handleDownloadFile(doc)}
                            // handleUploadFile={(e) => btnAction.handleUploadFile(e, file, isOverwriteSignature)}
                            handleShareFile={() => btnAction.handleShareFile(`${doc.FormName}`,`${doc.FormName}` , 1)}
                            // handleCopyLink={() => btnAction.handleCopyLink(`${doc.FormName}` , 1)}
                            templateFieldDisable={templateFieldDisable}
                            signButtonLabel={signButtonLabel}
                            clipboardState={copy}
                            key={doc.FormName}
                            formMode={mode}
                            showButtons={true}
                            layout={step === 1 ? "VERTICAL" : "HORIZONTAL"}
                        />
                )}
   

                     
                <Modal
                    isOpen={openedFile ? true : false}
                    title={`Signatories for ${openedFile?.FormName}`}
                    onModalClose={modalBtn.onModalClose}
                // onModalSubmit={modalBtnAction.onSubmit}
                >
                    {openedFile &&
                        <SignatoryPage
                            openedFile={openedFile}
                        />
                    }
                </Modal>

                {pageAlert.show &&
                    <AlertBar
                        showAlert={pageAlert.show}
                        severity={pageAlert.severity}
                        alertMessage={pageAlert.message}
                    />
                }
            </Grid>
        </>
    );
}

export default ViewPDFPage;